import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class CreateLeverantorsorderCommand extends BasicCommand<CreateLeverantorsorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<CreateLeverantorsorderCommand>;
    leverantorId: number;
    status: string;

    handelssortimentsgruppId: number;
    kvantitet: number;
    periodTom: string;
    periodFrom: string;
    egenBefraktning: boolean;
    mattslag: string;

    constructor() {
        super("CreateLeverantorsorderCommand", "leverantorsorder", CommandType.Replace);
    }
}
